"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from "prop-types";
import { DecorationElement } from "D5Utils/Objects";

var styles = function styles(theme) {
  return {
    decorText: {}
  };
};

var D5FormLayoutDecoration =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(D5FormLayoutDecoration, _PureComponent);

  function D5FormLayoutDecoration(props) {
    var _this;

    _classCallCheck(this, D5FormLayoutDecoration);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(D5FormLayoutDecoration).call(this, props));
    _this.decor = new DecorationElement(props.options);
    return _this;
  }

  _createClass(D5FormLayoutDecoration, [{
    key: "render",
    value: function render() {
      var classes = this.props.classes;
      return React.createElement(React.Fragment, null, !this.decor.isVisible ? null : React.createElement("div", {
        className: classes.decorText
      }, this.decor.title));
    }
  }]);

  return D5FormLayoutDecoration;
}(PureComponent);

_defineProperty(D5FormLayoutDecoration, "propTypes", {
  options: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  itemType: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  id: PropTypes.any.isRequired
});

export default withStyles(styles)(D5FormLayoutDecoration);